import 'hammerjs';

import { useTheme } from '@mui/material';
import {
  ChartArea,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartPane,
  ChartPanes,
  ChartSeries,
  ChartSeriesItem,
  ChartValueAxis,
  ChartValueAxisItem,
} from '@progress/kendo-react-charts';
import PropTypes from 'prop-types';
import { memo, useEffect, useState } from 'react';

import { useHandleSagaError } from '»utils/customHooks';

import { trlChartsServices } from '../TrlChart/trlCharts.services';
import { ChartStyled } from './TrlSimpleChart.styles';

export const TrlSimpleChart = memo(
  ({
    chartData,
    symbol,
    exchange,
    securityType,
    isCard,
    isCardMobileList,
    isCardMobileDetails,
    isCardDashboardMobileList,
  }) => {
    const theme = useTheme();

    const [closeData, setCloseData] = useState([]);

    const [timeData, setTimeData] = useState([]);

    const { handleSagaError } = useHandleSagaError();

    const saveReceivedData = (data) => {
      if (data.length > 0) {
        const { period } = data.shift();

        setCloseData(
          data.map((el) => {
            return el.entryPx;
          }),
        );

        if (period !== 'i') {
          setTimeData(
            data.map((el) => {
              return new Date(el.entryDate);
            }),
          );
        } else {
          setTimeData(
            data.map((el) => {
              const day = el.entryTime.slice(0, 5);
              return day;
            }),
          );
        }
      }
    };

    const callService = () => {
      trlChartsServices
        .instrumentGraphQuotes({ symbol, exchange, securityType })
        .then((resp) => {
          saveReceivedData([...resp]);
        })
        .catch((error) => {
          handleSagaError(error);
        });
    };

    useEffect(() => {
      if (isCard) {
        if (chartData?.length) saveReceivedData([...chartData]);
      } else if (chartData?.length) {
        saveReceivedData([...chartData]);
      } else {
        callService();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [chartData]);

    return (
      <ChartStyled
        isCard={isCard}
        transitions={!isCard && !isCardMobileList}
        isCardMobileList={isCardMobileList}
        isCardMobileDetails={isCardMobileDetails}
        isCardDashboardMobileList={isCardDashboardMobileList}
        hideChart={
          (isCardMobileList || isCardMobileDetails) &&
          closeData.length === 0 &&
          timeData.length === 0
        }
      >
        <ChartArea background="transparent" />
        <ChartAxisDefaults visible={false} />
        <ChartValueAxis>
          <ChartValueAxisItem name="cota" majorGridLines={{ visible: false }} />
        </ChartValueAxis>
        <ChartCategoryAxis>
          <ChartCategoryAxisItem
            categories={timeData}
            majorGridLines={{ visible: false }}
          />
        </ChartCategoryAxis>
        <ChartPanes>
          <ChartPane height="100%" background="transparent" />
        </ChartPanes>
        <ChartSeries>
          <ChartSeriesItem
            type="line"
            style="smooth"
            data={closeData}
            color={theme.palette.colors.mainFocused}
            markers={{ visible: false }}
            highlight={{ visible: false }}
          />
        </ChartSeries>
      </ChartStyled>
    );
  },
);

TrlSimpleChart.displayName = 'TrlSimpleChart';

TrlSimpleChart.propTypes = {
  chartData: PropTypes.array,
  symbol: PropTypes.string,
  exchange: PropTypes.string,
  securityType: PropTypes.string,
  isCard: PropTypes.bool,
  isCardMobileList: PropTypes.bool,
  isCardMobileDetails: PropTypes.bool,
  isCardDashboardMobileList: PropTypes.bool,
};
